import { useQuery, UseQueryResult, useQueryClient } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { UserInfo } from "#/lib/carrot-api/types/UserInfo"

export function useCompanyHasCostShare(): UseQueryResult<boolean, ResponseError> {
  return useQuery<UserInfo, ResponseError, boolean>(["CompanyHasCostShare"], () => carrotClient.getCurrentUser(), {
    select: (data: UserInfo) => data.companyHasCostShare,
    retry: buildCarrotApiRetryPolicy(3)
  })
}

export function useCreateCompanyHasCostShareOverride(): (value: boolean) => void {
  const queryClient = useQueryClient()
  return (value: boolean) => {
    queryClient.setQueryDefaults(["CompanyHasCostShare"], { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData<UserInfo>(["CompanyHasCostShare"], (oldData) => {
      if (!oldData) return oldData
      return { ...oldData, companyHasCostShare: value }
    })
  }
}
